// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F2RI","label":"styles_label__2MOCX"};